import { PhasrSidePanelDataProvider } from '../dataProvider/PhasrSidePanelDataProvider';
import { API_TYPE_GZ } from '../../webcomponents.constants';
import { BaseWebComponentDataProviderFactory } from '../../framework/BaseWebComponentDataProviderFactory';

export class PhasrSidePanelDataProviderFactory extends BaseWebComponentDataProviderFactory {
  constructor() {
    super();
    this.map.set(API_TYPE_GZ, PhasrSidePanelDataProvider);
  }
}
